import type { ConfiguracionLiquidacion, ResultadoLiquidacion } from './liquidacion';

export interface PesoEvolucion {
  lote_nave_id: number;
  nave_id: number;
  nave_codigo: string;
  aves_restantes: number;
  fecha_muestreo: string | null;
  antiguedad_dias: number | null;
  peso_medio_kg: string | null;
  kg_vivos: string | null;
  origen: 'muestreo' | 'historico' | 'ajustes' | 'pendiente';
  camadas_referencia: number[];
}
export interface DiaEvolucion {
  fecha: string;
  aves_entradas: number;
  bajas_registradas: number;
  aves_salidas: number;
  aves_restantes: number;
  kg_entrada: string;
  kg_salidas_confirmadas: string;
  kg_salida_simulado: string | null;
  kg_pienso: string | null;
  fecha_ultima_entrega: string | null;
  kg_ultima_entrega: string | null;
  pesos: PesoEvolucion[];
  partes_pendientes: number;
  cobertura_determinable: boolean;
  comparable: boolean;
  causas: string[];
  advertencias: string[];
  resultado: ResultadoLiquidacion | null;
}
export interface VentanaEvolucion {
  desde: string;
  hasta: string;
  variacion_total_eur: string;
  bajas_periodo: number;
  kg_entregados_periodo: string;
}
export interface EvolucionLiquidacion {
  camada_id: number;
  codigo_lote: string;
  fecha_calculo: string;
  fecha_desde: string;
  fecha_hasta: string;
  metodo_pienso: 'entregado_acumulado';
  configuracion: ConfiguracionLiquidacion;
  serie: DiaEvolucion[];
  ventanas: VentanaEvolucion[];
  peor_ventana: VentanaEvolucion | null;
}

/** Resta exacta antes de redondear para presentación. */
export function restarDecimal(a: string, b: string): string {
  function parse(value: string) {
    const m = /^([+-]?)(\d+)(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/.exec(value);
    if (!m) throw new Error('Decimal inválido');
    const exponent = Number(m[4] ?? 0);
    if (!Number.isInteger(exponent) || Math.abs(exponent) > 200)
      throw new Error('Exponente inválido');
    const fraction = m[3] ?? '';
    return {
      units: BigInt(m[2] + fraction) * (m[1] === '-' ? -1n : 1n),
      scale: fraction.length - exponent,
    };
  }
  const x = parse(a),
    y = parse(b),
    scale = Math.max(0, x.scale, y.scale);
  const difference =
    x.units * 10n ** BigInt(scale - x.scale) - y.units * 10n ** BigInt(scale - y.scale);
  const digits = (difference < 0n ? -difference : difference).toString().padStart(scale + 1, '0');
  const value = scale
    ? `${digits.slice(0, -scale)}.${digits.slice(-scale)}`.replace(/0+$/, '').replace(/\.$/, '')
    : digits;
  return `${difference < 0n ? '-' : ''}${value}`;
}

export function fechaEvolucion(fecha: string): string {
  return new Intl.DateTimeFormat('es-ES').format(new Date(`${fecha}T12:00:00`));
}
